import Detenteur from "../models/Detenteur";
import localforage from "localforage";

class Asynchro
{

    static workerData(data)
    {
        if (typeof data === "object") {
            if (data.action === "asynchro") {

                if(data.type === "detenteurs") {
                    Detenteur.stockDetenteursOnLocal(data.data).then(function () {
                        localStorage.setItem('asyncDetenteurs', false);
                        const event = new Event('localStorageAsyncDetenteurs');
                        window.dispatchEvent(event);
                    })
                }


                if(data.type === "otags") {
                    let otags = data.data.otags;
                    localforage
                        .setItem('OTAGS', JSON.stringify(otags))
                        .then(function () {
                            console.log('otags stockés');
                        })
                }

            }
        }
    }

}
export default Asynchro;



// WEBPACK FOOTER //
// ./src/js/core/Asynchro.js